import React from 'react';
import { useNavigate } from 'react-router-dom';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import PhoneIcon from '@mui/icons-material/PhoneIphone';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import WorkIcon from '@mui/icons-material/Work';
import ListAltIcon from '@mui/icons-material/ListAlt';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';
import ApartmentIcon from '@mui/icons-material/Apartment';
import URL from '@/common/routes/Url';

const AdminListItems: React.FC = () => {
  const [nestopen, setNestOpen] = React.useState(false);

  const handleClick = () => {
    setNestOpen(!nestopen);
  };

  const navigate = useNavigate();

  const toEmployees = () => {
    navigate(URL.employees);
  };

  const toDepartments = () => {
    navigate(URL.departments);
  };
  const toPhones = () => {
    navigate(URL.phones);
  };
  const toStyles = () => {
    navigate(URL.styles);
  };
  const toStatuses = () => {
    navigate(URL.statuses);
  };
  const toCompany = () => {
    navigate(URL.company);
  };

  return (
    <List>
      <ListItemButton onClick={handleClick}>
        <ListItemIcon>
          <VpnKeyOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary="管理メニュー" />
        {nestopen ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={nestopen} timeout="auto" unmountOnExit>
        <List component="div" dense disablePadding>
          <ListItemButton sx={{ pl: 4 }} onClick={toEmployees}>
            <ListItemIcon>
              <BadgeOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="社員マスタ" />
          </ListItemButton>

          <ListItemButton sx={{ pl: 4 }} onClick={toDepartments}>
            <ListItemIcon>
              <ListAltIcon />
            </ListItemIcon>
            <ListItemText primary="部署マスタ" />
          </ListItemButton>

          <ListItemButton sx={{ pl: 4 }} onClick={toPhones}>
            <ListItemIcon>
              <PhoneIcon />
            </ListItemIcon>
            <ListItemText primary="共有電話マスタ" />
          </ListItemButton>

          <ListItemButton sx={{ pl: 4 }} onClick={toStyles}>
            <ListItemIcon>
              <WorkIcon />
            </ListItemIcon>
            <ListItemText primary="勤務形態マスタ" />
          </ListItemButton>

          <ListItemButton sx={{ pl: 4 }} onClick={toStatuses}>
            <ListItemIcon>
              <PersonPinIcon />
            </ListItemIcon>
            <ListItemText primary="ステータスマスタ" />
          </ListItemButton>

          <ListItemButton sx={{ pl: 4 }} onClick={toCompany}>
            <ListItemIcon>
              <ApartmentIcon />
            </ListItemIcon>
            <ListItemText primary="会社マスタ" />
          </ListItemButton>
        </List>
      </Collapse>
    </List>
  );
};
export default AdminListItems;
